import { UseFormReturn } from "react-hook-form";
import { startOfMonth } from "services/DateService";
import { catchRestError, PageableResponse, RestClient } from "..";
import { MSystemGet } from "../common";

export type B020030FindRequest = {
  shokaKbn: string;
  eigyoCd: string;
} & Partial<{
  uriYmdFrom: string;
  uriYmdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  uridenpyoNoFrom: string;
  uridenpyoNoTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  tokuiCd: string;
  tokuishitenCd: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  shainCdFrom: string;
  shainCdTo: string;
  chumonNo: string;
  nonyuCd: string;
  nonyushitenCd: string;
  shohinCd: string;
  janCd: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B020030FindResponse = {
  uriYmd: string;
  uchiwakeKbn: string;
  shohinCd: string;
  shohinNm: string;
  juchudenpyoNo: string;
  uridenpyoNo: string;
  chumonNo: string;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  nonyuNm: string;
  urisu: string;
  shukasu: string;
  shainCd: string;
  bumonCd: string;
  uriKin: string;
  arariKin: string;
  arariRitsu: string;
};

export const B020030Find = (props: B020030FindRequest) => {
  return RestClient.get<PageableResponse<B020030FindResponse>>("b020030/find", {
    params: props,
  });
};

export const B020030TogetsuYm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  await MSystemGet()
    .then((response) => {
      const firstYmd = startOfMonth(response.data.B020030TogetsuYm);
      // 売上日の範囲(開始)初期設定
      methods.setValue("uriYmdFrom", firstYmd);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("uriYmdFrom", "");
    });
};
